import AccessDetail from './AccessDetail';

export default AccessDetail;
